module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/rumble-4aeb3118990ee44eac89dcb267f0b1b5.png";